import { render, staticRenderFns } from "./ComponentWithStyledBorder.vue?vue&type=template&id=ff2316ae&scoped=true&"
import script from "./ComponentWithStyledBorder.vue?vue&type=script&lang=js&"
export * from "./ComponentWithStyledBorder.vue?vue&type=script&lang=js&"
import style0 from "./ComponentWithStyledBorder.vue?vue&type=style&index=0&id=ff2316ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2316ae",
  null
  
)

export default component.exports